/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterConstraintBaseForString extends models.ParameterConstraintBase {
    getFixupPrototypeFunction() { return ParameterConstraintBaseForString.fixupPrototype; }

    static newInstance(model: Partial<ParameterConstraintBaseForString>): ParameterConstraintBaseForString {
        let obj = Object.assign(new ParameterConstraintBaseForString(), model);
        ParameterConstraintBaseForString.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterConstraintBaseForString>): ParameterConstraintBaseForString {
        if (!model) return null;
        return ParameterConstraintBaseForString.newInstance(<ParameterConstraintBaseForString> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterConstraintBaseForString) {
        if (!obj) return;

        models.ParameterConstraintBaseForString.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterConstraintBaseForString): boolean {
        if (models.ParameterConstraintBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterConstraintBaseForString.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
